import React, { Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Breadcrumb, Button, Card, Col, Icon, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import style from '../../../../components/Sales/style.css'
import { numVal, strVal } from '../../../../modules/Utils'
import { get } from 'lodash'
import CustomSpin from '../../../../elements/CustomSpin'
import Status from '../../../../elements/Status'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import SalariesLinesCont from '../../../../components/People/Salaries/Lines/SalaryLinesCont'
import Amount from '../../../../components/Common/Amount'
import { streamUrl } from '../../../../variables'
import IconText from '../../../../elements/IconText'
import Authentication from '../../../../modules/Authentication'

const { TabPane } = Tabs

AddSalary.propTypes = {}
const auth = new Authentication()

function AddSalary (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    fetchingActions,
    submit,
    fetch,
    update,
    actions,
    salary,
    handleActions,
    setSalary,
    onHold,
  } = props

  const isNew = type === 'new'
  const isConfirmed = ['Confirmed'].includes(salary.status)
  const isUpdatable = actions.find((a) => a.key === 'update')
  const Operations = ({ salary, ...rest }) => {
    let ops = actions
      .filter((a) => a.key !== 'update')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    salary.status === 'Confirmed' &&
    ops.push(
      <span>
          <Popconfirm
            placement="left"
            title={`Are you sure you want to Hold?`}
            onConfirm={onHold}
            okText="Yes"
            cancelText="No">
            <a>{salary.paymentStatus === 'New' ? 'Hold' : 'Unhold'}</a>
          </Popconfirm>
        </span>,
    )
    if (ops.length > 0 && !isConfirmed) {
      ops.push(
        <a target={'_blank'} href={`${streamUrl}pdf/${salary._id}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'}/>
        </a>,
      )
    }

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr]) : []}
      </div>
    )
  }

  const SubmitButton = () => (
    <Button
      style={{ float: 'right', marginBottom: 10 }}
      icon={'form'}
      loading={updating || submitting}
      type="primary"
      onClick={type !== 'edit' ? submit : update}>
      {type === 'edit' ? 'Apply Changes' : 'Submit'}
    </Button>
  )
  return (
    <CustomSpin spinning={fetching || fetchingActions}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>People</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/people/salaries`}>Salaries</Breadcrumb.Item>
            <Breadcrumb.Item>{type === 'new' ? 'New Salary' : salary.code}</Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Salary</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={15}>
                <h3 className={style.title}>
                  <h2 className={'icon-text-header'}>
                    <Icon
                      type="barcode"
                      style={{
                        marginRight: '5px',
                        color: '#08c',
                      }}
                    />
                    <Tooltip title="Employee Name">{strVal(salary, 'employee.fn')}</Tooltip>
                  </h2>

                  <Status value={strVal(salary, 'status')}/>
                  {/*<Operations*/}
                  {/*  style={{marginTop: '10px', marginBottom: '10px'}}*/}
                  {/*  salary={salary}*/}
                  {/*  status={strVal(salary, 'status')}*/}
                  {/*/>*/}
                  <Row>
                    <Col span={8}>
                      <Link to={`/people/payrolls/${strVal(salary, 'payroll._key')}/update`}>
                        {strVal(salary, 'payroll.code')}
                      </Link>
                    </Col>
                    <Col span={8}>{strVal(salary, 'date')}</Col>
                    <Col span={8}>{strVal(salary, 'company.fn')}</Col>
                  </Row>
                </h3>
              </Col>
              <Col span={7}>
                <Amount data={[{ name: 'Amount', amount: numVal(salary, 'amount') }]} currency={salary.currency}/>
              </Col>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey={get(props, 'location.hash') || '#lines'} onChange={(key) => props.history.push(key)}>
          {/*<TabPane*/}
          {/*  tab={*/}
          {/*    <span>*/}
          {/*      <Icon type="info-circle" />*/}
          {/*      Details*/}
          {/*    </span>*/}
          {/*  }*/}
          {/*  key="#details">*/}
          {/*  {(isUpdatable || isNew) && (*/}
          {/*    <Row>*/}
          {/*      <SubmitButton />*/}
          {/*    </Row>*/}
          {/*  )}*/}
          {/*  <SalariesForm ref={formRef} {...props} />*/}
          {/*  {(isUpdatable || isNew) && (*/}
          {/*    <Row>*/}
          {/*      <SubmitButton />*/}
          {/*    </Row>*/}
          {/*  )}*/}
          {/*</TabPane>*/}
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="ordered-list"/> Lines
              </span>
            }
            key="#lines">
            <SalariesLinesCont salary={salary} setMain={setSalary} isUpdatable={isUpdatable}/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="copy"/>
                History
              </span>
            }
            key="#history">
            <History isArray={true} loading={fetching} owner={salary}/>
          </TabPane>
          <TabPane
            disabled={type !== 'edit'}
            tab={
              <span>
                <Icon type="folder-open"/>
                Documents
              </span>
            }
            key="#docs">
            <DocumentsCont email={true} emailLabel={'Email with Salary'} owner={salary}/>
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default withRouter(AddSalary)
